import { SUPPORTED_LOCALES } from '@/constants/languages'
import tenants from '@/generated/tenants.json'

const getDomainLangPaths = () => {
  return tenants.flatMap((tenant) =>
    SUPPORTED_LOCALES.map((lang) => ({
      params: {
        domain: tenant.domain,
        lang,
      },
    })),
  )
}

export default getDomainLangPaths
